import { ReactNode, RefObject } from 'react'

import styles from './OffCanvasDialog.module.scss'

export type OffCanvasDialogProps = {
	isClosing: boolean
	isOpened: boolean
	forwardedRef: RefObject<HTMLDivElement>
	hidden?: boolean
	children?: ReactNode
}

export const OffCanvasDialog = ({
	isClosing,
	isOpened,
	children,
	forwardedRef,
	hidden = false
}: OffCanvasDialogProps): JSX.Element => (
	<div
		hidden={hidden}
		className={[
			styles.offCanvasDialog,
			!isClosing && !isOpened ? styles.offCanvasDialog_closed : null,
			isClosing ? styles.offCanvasDialog_closing : null,
			!isClosing && isOpened ? styles.offCanvasDialog_opening : null
		]
			.filter(Boolean)
			.join(' ')}
		role="dialog"
		aria-label="Catalog menu"
		id="menu-popup"
		ref={forwardedRef}>
		{children}
	</div>
)
